import { cn } from '@helpers/cn';

import { ModalFooter } from '..';
import { TProps } from '../types/TProps';

export const ModalFooterEnd = ({ children, className }: TProps) => (
  <ModalFooter className={cn('modal-footer--end', className)}>{children}</ModalFooter>
);
